import { styled } from '@mui/material/styles';
import {
  keyframes,
  Paper,
  Box,
  TableCell,
  ToggleButtonGroup,
  Card,
  IconButton,
  Button,
  Grid,
  Link,
  FormGroup,
  FormControl,
  Typography as MuiTypography,
  Divider,
  FormLabel,
  ListItem,
  ListItemButton,
  TableContainer,
  Stepper, 
  Avatar,
  TextField,
  TableRow,
  ListItemText, 
  Alert
} from '@mui/material';
import AutorenewIcon from "@mui/icons-material/Autorenew";
import CloseIcon from "@mui/icons-material/Close";
import { tableCellClasses } from "@mui/material/TableCell";
import Typography from '../components/Typography';
import { NavLink } from 'react-router-dom';



export const StyledItem = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    backgroundColor: theme.palette.background.common,
})); 

export const StyledBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
}));

export const StyledSupportBox = styled('div')({
  padding: '20px',
});

export const StyledDividerBox = styled(Box)(({ theme }) => ({
    borderBottom: `1px solid ${theme.palette.divider}`,
}));

export const SupportStyledItem = styled('div')(({ theme }) => ({
  border: `1px solid ${theme.palette.common.greyBorder}`,
  borderRadius: '20px',
  padding: theme.spacing(3),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  backgroundColor: theme.palette.background.common,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '480px',
  maxWidth: '480px',
  margin: "auto",
  [theme.breakpoints.down('sm')]: {
    width: '320px',
    maxWidth: '320px',
  },
}));

export const StyledCenteredBox = styled("div")(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const StyledOSIcons = styled("div")(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  gap: '32px',
  marginBottom: "18px",
  marginTop: "26px",
  color: theme.palette.text.primary,
    [theme.breakpoints.down('sm')]: {
    gap: '18px',
  },
}));

export const StyledLabelBox = styled(Box)(({ theme }) => ({
  border: `1px solid black`,
  width: 760,
  height: 640,
  backgroundColor: "white",
  color : "black"
}));

export const StyledVersionsBox = styled(Grid)(() => ({
  flexGrow: 1,
  minWidth: "200px",
  maxWidth: "760px", 
  marginLeft: "10px",
  marginTop: "10px"
}))

export const StyledTableContainer = styled(TableContainer)(() => ({
    height: "100%",
})); 

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
	fontWeight: "bold",
  color: theme.palette.common.white,
}));
export const StyledTableStickyCell = styled(TableCell)(() => ({
	[`&.${tableCellClasses.body}`]: {
		paddingLeft: "10px",
		paddingRight: "10px",
		width: "40px"
	},
}));
export const StyledResultTableCell = styled(TableCell)(() => ({
	[`&.${tableCellClasses.body}`]: {
		paddingLeft: "10px",
		paddingRight: "10px",
	},
}));

export const StickyCell = styled(StyledResultTableCell)(({ theme }) => ({
  position: "sticky",
  left: 0,
  zIndex: 3,
  backgroundColor: theme.palette.common.stickyCell,
  boxShadow: "2px 0px 4px rgba(0, 0, 0, 0.1)",
}));

export const StickyNameCell = styled(StyledResultTableCell)(({ theme }) => ({
  position: "sticky",
  left: 50,
  zIndex: 2,
	backgroundColor: theme.palette.common.stickyCell,
	boxShadow: "2px 0px 4px rgba(0, 0, 0, 0.1)",
	width: 220,
}));

export const StyledTableHeadCell = styled(TableCell)(({ theme }) => ({
	[`&.${tableCellClasses.head}`]: {
		backgroundColor: theme.palette.primary.main,
		color: theme.palette.common.white,
		fontSize: 16,
		fontWeight: 600,
		paddingLeft: "5px",
		paddingRight: "10px",
		whiteSpace: "nowrap",
		paddingTop: "15px", 
		paddingBottom: "15px",
	}
}));

export const StickyHeadCell = styled(StyledTableHeadCell)(({ theme }) => ({
	position: "sticky",
	left: 0,
	zIndex: 3,
	backgroundColor: theme.palette.primary.main,
}));

export const StickyNameHeadCell = styled(StyledTableHeadCell)(({ theme }) => ({
	position: "sticky",
	left: 50,
	zIndex: 3,
	backgroundColor: theme.palette.primary.main,
	width: 220,
}));

export const UsersTableContainer = styled(TableContainer)(({ theme }) => ({
  borderRadius: 4,
  margin: "10px 10px",
  maxWidth: "960px",
  width: "auto",
  backgroundColor: theme.palette.background.common,
})); 


//urlChecker

export const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const RotatingIcon = styled(AutorenewIcon)(({theme}) => ({
    animation: `${rotate} 2s linear infinite`,
    color: theme.palette.info.main
}));

export const StyledCardContainer = styled(Card)(({theme}) => ({
  backgroundColor: theme.palette.background.common,
}));

export const StyledIcon = styled('div')(({ hoverColor }) => ({
  fontSize: '35px',
  transition: 'color 0.3s',
  cursor: "pointer",
  '&:hover': {
    color: hoverColor,
  },
}));

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  marginRight: theme.spacing(2),
  color: theme.palette.primary.main,
  "&:hover": {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  width: '50px',
  height: '40px',
  borderRadius: '5px',
  border: `1px solid ${theme.palette.primary.main}`,
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  
})); 

export const StyledButton = styled(Button)(({ theme }) => ({
  color: theme.palette.common.white,
})); 

export const StyledLink = styled(Link)(({ theme }) => ({
  '&:hover': {
    color: theme.palette.primary.main,
  },
}));

export const StyledListItem = styled(ListItem)(() => ({
 root: {
    "&:hover": {
      color: "white",
    },
  },
})); 

export const StyledListItemButton = styled(ListItemButton)(() => ({
  root: {
     "&:hover": {
       color: "white",
     },
   },
 })); 


export const StyledCloseIcon = styled(CloseIcon)(({ theme }) => ({
  fontSize: 24,
  overflow: "visible",
  cursor: "pointer",
  color: theme.palette.main,
  transition: "color 0.3s ease, transform 0.3s ease",
  "&:hover": {
    color: theme.palette.error.main,
    transform: "scale(1.1)",
  },
}));

export const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
        '& .MuiToggleButtonGroup-grouped': {
          '&:not(:first-of-type)': {
            borderRadius: theme.shape.borderRadius,
          },
          '&:first-of-type': {
            borderRadius: theme.shape.borderRadius,
          },
          "&.Mui-selected, &.Mui-selected:hover": {
            color: "white",
            backgroundColor: theme.palette.primary.main,
          }
        },
}));
    
export const StyledTestSessionBox = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: '100vw',
  height: '100vh',
  maxHeight: "100vh",
  border: "2px #000",
  borderRadius: 2,
  backgroundColor: theme.palette.background.common,
  display: 'flex',
  flexDirection: 'column',
  overflow: "hidden",
  boxSizing: "border-box",

  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(1),
  },

  [theme.breakpoints.down("xs")]: {
    padding: theme.spacing(0.5),
    borderRadius: 0,
  },
}));

export const StyledContentBox = styled(Box)(() => ({
  flex: 1,
  overflowY: "auto",
  display: "flex",
  flexDirection: "column",
  minHeight: 0,
}));

export const StyledDivider = styled(Divider)(() => ({
  flex: 1,
  borderColor: "#7C7C7C"
}));

export const StyledSessionContentWrapper = styled(Box)(() => ({
  width: "100%",
  height: "100%",
  alignContent: "center"
}));

export const StyledSessionInnerLayout = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  minHeight: "100%",
  maxHeight: "90vh",
  height: "auto",
  flexGrow: 1,
  width: "100%",
  gap: theme.spacing(2),
  alignItems: "stretch",

  [theme.breakpoints.up("lg")]: {
    flexDirection: "row",
    maxHeight: "70vh",
    gap: 0,
  },
}));

export const StyledSessionLeftColumn = styled(Box)(({ theme }) => ({
  flex: 1,
  minWidth: 0,
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  flexGrow: 1,
  height: "auto",
  marginLeft: 0,

  [theme.breakpoints.up("lg")]: {
    marginLeft: theme.spacing(3),
  },
  [theme.breakpoints.up("md")]: {
    flex: 1.5,
  },
}));

export const StyledSessionRightColumn = styled(Box)(({ theme }) => ({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  height: "auto",
  aspectRatio: "16 / 9",
  gap: theme.spacing(1),
}));

export const StyledNotesAndAlertBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginTop: theme.spacing(1),
  width: "100%",
  gap: theme.spacing(1.5),

  [theme.breakpoints.up("xl")]: {
    gap: theme.spacing(2),
  },
  [theme.breakpoints.up("lg")]: {
    width: "95%",
  },
}));

export const StyledNotesWrapper = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(1),
  width: "100%",
  [theme.breakpoints.up("lg")]: {
    width: "95%",
  },
}));

export const StyledWarningAlert = styled(Alert)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  textAlign: "left",
  border: `1px solid ${theme.palette.common.greyBorder}`,
  borderRadius: theme.shape.borderRadius * 2,
  paddingLeft: theme.spacing(1.5),
  paddingRight: theme.spacing(1.5),
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),

  fontSize: 13,

  [theme.breakpoints.up("sm")]: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    fontSize: 14,
  },

  [theme.breakpoints.up("lg")]: {
    fontSize: 16,
  },
}));

export const StyledVFMapWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  flex: 1,
  minHeight: 0,
  width: "100%",
  gap: theme.spacing(1),
  padding: theme.spacing(1),
  backgroundColor: theme.palette.common.backgroundBox,
  border: `1px solid ${theme.palette.common.greyBorder}`,

  [theme.breakpoints.up("xl")]: {
    gap: theme.spacing(2),
  },
  [theme.breakpoints.up("lg")]: {
    width: "95%",
  },
}));

export const StyledProgressBarWrapper = styled(Box, {
  shouldForwardProp: (prop) => !['fullscreenVideo', 'isSmallOrSmaller'].includes(prop),
})(({ theme, fullscreenVideo, isSmallOrSmaller }) => ({
  position: fullscreenVideo || isSmallOrSmaller ? "relative" : "absolute",
  top: fullscreenVideo || isSmallOrSmaller ? "auto" : "calc(100% - 65px)",
  left: fullscreenVideo || isSmallOrSmaller ? "auto" : "50%",
  transform: fullscreenVideo || isSmallOrSmaller ? "none" : "translateX(-50%)",
  width:
    fullscreenVideo || isSmallOrSmaller
      ? "100%"
      : "80vw",
  display: fullscreenVideo ? "none" : "flex",
  justifyContent: "center",
  zIndex: 1200,
  pointerEvents: "none",
  marginTop: isSmallOrSmaller ? theme.spacing(1) : 0,
  marginBottom: isSmallOrSmaller ? theme.spacing(1) : 0,

  [theme.breakpoints.up("sm")]: {
    width: fullscreenVideo || isSmallOrSmaller
      ? "100%"
      : 300,
  },
  [theme.breakpoints.up("md")]: {
    width: fullscreenVideo || isSmallOrSmaller
      ? "100%"
      : 400,
  },
  [theme.breakpoints.up("lg")]: {
    width: fullscreenVideo || isSmallOrSmaller
      ? "100%"
      : 480,
  },
}));


export const StyledVFMapContainer = styled(Box)({
  flex: 1,
  width: "100%",
  maxWidth: 540,
  aspectRatio: "1.25",
  height: "auto",
  overflow: "hidden",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  margin: "0 auto",
});

export const StyledProgressBarBox = styled(Box)({

});


export const StyledLiveStreamBox = styled(Box)(({ theme, isFullscreen, isLandscape }) => ({
  height: isFullscreen ? "100%" : "auto",
  position: isFullscreen ? "absolute" : "relative",
  top: isFullscreen ? (isLandscape ? "0vh" : "50%") : "unset",
  left: isFullscreen ? "50%" : "unset",
  transform: isFullscreen
    ? isLandscape
      ? "translateX(-50%)"
      : "translate(-50%, -50%)"
    : "none",
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
  alignItems: "center",
  overflow: "hidden",
  backgroundColor: isFullscreen ? "black" : theme.palette.background.default,
  overflowY: "auto",
  width: "100%",

  ...(isFullscreen
    ? {}
    : {
        [theme.breakpoints.up("lg")]: {
          width: "95%",
        },
      }),
}));

export const StyledEyeIndicatorBar = styled(Box)(({ theme}) => ({
  display: 'flex',
  justifyContent: 'space-around',
  alignItems: 'center',
  backgroundColor: theme.palette.common.secondaryLight,
  borderRadius: theme.shape.borderRadius * 2,
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  border: `1px solid ${theme.palette.common.greyBorder}`,
  borderBottom: 'none',
  boxShadow: theme.shadows[1],
  width: "100%",

  // Responsive vertical padding
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),

  [theme.breakpoints.up('md')]: {
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
  },
  [theme.breakpoints.up('lg')]: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    width: "95%",
  },
  [theme.breakpoints.up('xl')]: {
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
  },
}));


export const StyledFullscreenButton = styled(IconButton)(({ isFullscreen }) => ({
  position: "absolute",
  top: "10px",
  right: "10px",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  color: "white",
  zIndex: isFullscreen ? 1300 : "auto",
  "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.7)" },
}));

export const StyledFullscreenBox = styled(Box)(() => ({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(0, 0, 0, 0.9)",
  zIndex: 1000,
  transition: "all 0.3s ease-in-out",
}));

export const StyledActionBarBox = styled(Box)(({ theme, fullscreenVideo, showActionBar }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  backgroundColor: fullscreenVideo !== null ? "rgba(0, 0, 0, 0.7)" : "rgba(0, 0, 0, 0)",
  position: fullscreenVideo ? "fixed" : "relative",
  bottom: fullscreenVideo !== null ? 0 : "auto",
  left: fullscreenVideo !== null ? 0 : "auto",
  width: "100%",
  display: showActionBar ? "flex" : "none",
  justifyContent: "space-between",
  zIndex: 1300,
  height: showActionBar ? "auto" : "0px",
  overflow: "hidden",
  transition: "display 0.9s ease-in-out, height 0.9s ease-in-out",
  borderTop: fullscreenVideo ? "none" : `1px solid ${theme.palette.common.lightGrey}`,
}));



export const getStatusTypographyStyle = (status, theme) => ({
  color:
    status === "down"
      ? theme.palette.error.main
      : status === "starting"
      ? theme.palette.warning.main
      : status === "checking"
      ? theme.palette.info.main
      : theme.palette.primary.main,
});

export const AuthContainer = styled('div')({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  maxWidth: "800px",
}); 

export const StyledFormGroup = styled(FormGroup)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

export const StyledFormControl = styled(FormControl)(() => ({
  width: "100%"
}));

export const StyledTypography = styled(MuiTypography)(({ theme }) => ({
  textAlign: "left",
  paddingBottom: theme.spacing(2),
  fontSize: "16px",
  paddingLeft: "10px",
})); 

export const StyledSupportDivider = styled(Divider)(() => ({
  width: '40%',
  height: "2px",
  backgroundColor: '#D9D9D9',
  '&.MuiDivider-root': {
    margin: '10px 0',
  },
}));

export const StyledDNSInstructionsModal = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 520,
  backgroundColor: theme.palette.background.common,
  boxShadow: 24,
  padding: 32,
  overflow: 'auto',
  maxHeight: 'auto',
  [theme.breakpoints.down("sm")]: {
    width: "80%",
    '@media (orientation: landscape)': {
    maxHeight: '80%',
  },
  },
}));

export const StyledInstructionsModalHeader = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: 16,
}));

export const StyledInstructionsButton = styled(Box)(() => ({
  marginTop: 32,
  display: 'flex',
  justifyContent: 'flex-end',
}));

export const StyledAuthError = styled(FormLabel)(({ theme }) => ({
  color: theme.palette.error.main,
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
}));

export const StyledStatusTypography = styled(MuiTypography)(() => ({
  fontSize: "16px",
  color: "white",
  borderRadius: 8,
  padding: "3px 10px",
  display: "inline-block",
}));

export const StyledButtonsBox = styled(Box)(() => ({
  display: "flex",
  justifyContent: "flex-end"
})); 

export const StyledButtonWrapper = styled(Box)(({ theme }) => ({
  margin: theme.spacing(1),
  position: 'relative'
}));

export const StyledStepper = styled(Stepper)(({ theme }) => ({
  padding: theme.spacing(3)
})); 

export const StyledPaper = styled(Paper)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  padding: theme.spacing(4),
  [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
    marginBottom: theme.spacing(6),
    padding: theme.spacing(4),
  },
}));

export const StyledLayoutRoot = styled('div')(({ theme }) => ({
  width: "auto",
  // marginLeft: theme.spacing(3),
  // marginRight: theme.spacing(2),
  [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
    // width: 600,
    marginLeft: "auto",
    marginRight: "auto",
  },
})); 

export const StyledDeviceLabelGrid = styled(Grid)(({ theme }) => ({
  marginLeft: "10px",
  marginTop: "10px",
  [theme.breakpoints.down('md')]: {
    overflow: "auto",
  },
})); 

export const StyledFooter = styled('div')(() => ({
  padding: '1rem',
  textAlign: 'center',
  marginTop: 'auto'
}));

export const StyledUserCard = styled(Card)(({ theme }) => ({
  '&.MuiCard-root': {
    background: theme.palette.common.userCard,
    color: theme.palette.common.white,
  }
}));

export const StyledUserCardAvatar = styled(Avatar)(({ theme }) => ({
  '&.MuiAvatar-root': {
    width: "70px",
    height: "70px",
    backgroundColor: theme.palette.primary.main,
  },
}));

export const StyledPageNumber = styled('span')(({ theme }) => ({
  margin: theme.spacing(0.5),
  cursor: 'pointer',
  display: 'inline-block',
  width: 25,
  height: 25,
  lineHeight: '25px',
  borderRadius: '50%',
  textAlign: 'center',
  '&:hover': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
}));

export const StyledActivePageNumber = styled('span')(({ theme }) => ({
  margin: theme.spacing(0.5),
  display: 'inline-block',
  width: 25,
  height: 25,
  lineHeight: '25px',
  borderRadius: '50%',
  textAlign: 'center',
  fontWeight: 'bold',
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
})); 

export const StyledNotesContainer = styled(Box)(() => ({
  position: "relative",
})); 

export const StyledNotesField = styled(TextField, {
  shouldForwardProp: (prop) => prop !== 'limitReached',
})(({ theme, limitReached }) => ({
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: limitReached ? theme.palette.warning.main : "",
    },
    '&:hover fieldset': {
      borderColor: limitReached ? theme.palette.warning.main : theme.palette.primary.main,
    },
    '&.Mui-focused fieldset': {
      borderColor: limitReached ? theme.palette.warning.main : theme.palette.primary.main,
    },
  },
  '& .MuiInputLabel-root': {
    color: limitReached ? theme.palette.warning.main : undefined,
    '&.Mui-focused': {
      color: limitReached ? theme.palette.warning.main : undefined,
    },
  },
}));

export const StyledSearchField = styled(TextField)(() => ({
  '& .MuiOutlinedInput-root': {
    paddingRight: 0,
    width: 200
  }
})); 

export const StyledHealthCheckTableCell = styled(TableCell)(() => ({
  width: 100,
  "&.MuiTableCell-root": {
    padding: "6px",
  },
}));

export const StyledPageSpinner = styled('div')(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
  width: "100%",
})); 

export const StyledStatusText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'iconcolor',
})(({ iconcolor }) => ({
  fontSize: '14px',
  color: iconcolor,
  margin: 0,
}));

export const progressAnimation = keyframes`
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
`;

export const StyledProgressTableRow = styled(TableRow, {
  shouldForwardProp: (prop) => prop !== 'value',
})(({ theme, value }) => {
  let percentage = 0;

  if (value <= 20) {
    percentage = 20;
  } else if (value <= 86) {
    percentage = 86;
  } else if (value <= 98) {
    percentage = 98;
  } else {
    percentage = 100;
  }

  return {
    backgroundImage: `linear-gradient(to right, ${theme.palette.common.lightGrey} ${percentage}%, ${theme.palette.background.default} ${percentage}%)`,
    backgroundPosition: '0 0',
    animation: `${progressAnimation} 1s linear infinite`,
  };
});

export const SidebarContainer = styled('aside', {
  shouldForwardProp: (prop) => prop !== 'isopen',
})(({ theme, isopen }) => ({
  position: 'fixed',
  top: 0,
  bottom: 0,
  left: isopen ? 0 : -224, 
  zIndex: 5,
  width: 224,
  fontWeight: 400,
  color: '#fff',
  backgroundPosition: 'center center',
  backgroundSize: 'cover',
  transition: 'left 0.2s ease-in',

  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 2,
    width: '100%',
    height: '100%',
    display: "block",
    background: '#000',
    opacity: 0.33,
  },

  '&::after': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 3,
    width: '100%',
    height: '100%',
    background: "#00b398",
    background: "linear-gradient(to bottom, #00b398, #007864)",
    opacity: 1,
  },

  '&[data-image]::after': {
  opacity: 0.77,
},

  [`@media (max-width:768px)`]: {
    width: '100%',
    left: isopen ? 0 : '-100%',
    '&::before, &::after': {
      opacity: 1,
    },
  },
}));


export const SidebarContent = styled('div')(() => ({
  position: 'relative',
  zIndex: 4,
  height: 'calc(100vh - 20px)',
  paddingBottom: 30,
  overflowY: 'auto',
  overflowX: 'hidden',
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',
  '&::-webkit-scrollbar': {
    width: 0,
  },
  display: 'flex',
  flexDirection: 'column',
}));


export const SidebarBackground = styled('div')(() => ({
  position: 'absolute',
  top: 0,
  left: 0,
  zIndex: 1,
  display: "block",
  width: '100%',
  height: '100%',
  backgroundPosition: 'center center',
  backgroundSize: 'cover',
  backgroundRepeat: "no-repeat",
}));

export const StyledNavLink = styled(NavLink)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(1),
  color: '#f8f9fa',
  textDecoration: 'none',
  fontSize: '1rem',
  width: '100%',
  '&:hover': {
     backgroundColor: theme.palette.action.hover,
  },
  '&.active': {
    color: '#fff',
    opacity: 1,
    backgroundColor: theme.palette.action.selected,
  },
})); 

export const SidebarNavItemIcon = styled('div')(() => ({
  minWidth: '56px',
  display: 'inline-flex',
  alignItems: 'center',
  flexShrink: 0
})); 

export const SidebarListText = styled(ListItemText)(() => ({
  textTransform: 'uppercase',
  marginLeft: '-20px',
})); 

export const AppWrapper = styled('main')(() => ({
  display: 'flex',
  width: '100%',
  height: '100%',
  padding: 0,
  margin: 0,
  overflowX: 'hidden',
}));

export const EmptyAppWrapper = styled('main')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  padding: 0,
  margin: 0,
  overflowX: 'hidden',
  backgroundColor: theme.palette.grey[100],
}));

export const StyledContent = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isSidebarOpen',
})(({ isSidebarOpen}) => ({
  display: 'inline-flex',
  flexDirection: 'column',
  flexGrow: 1,
  width: '100%',
  minHeight: '100vh',
  padding: 0,
  margin: 0,
  overflowX: 'hidden',
  transition: 'margin 0.2s ease-in',
  marginLeft: isSidebarOpen ? 224 : 0,
}));

export const LogoWrapper = styled('span')(({ theme }) => ({
  color: theme.palette.common.white,
  display: 'flex',
  alignItems: 'center',
  marginLeft: '-10px',
  img: {
    margin: '0px 8px 2px 6px',
  },
}));

export const PageWrapper = styled(Box)(({ theme }) => ({
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
}));

export const PageHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  alignSelf: 'center',
  padding: '0.1rem',

  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
}));

export const PageTitle = styled('div')(({ theme }) => ({
  paddingRight: '0.5rem',
  marginBottom: '0.5rem',

  [theme.breakpoints.down('sm')]: {
    marginBottom: 0,
  },
}));

export const PageSpinner = styled('div')(() => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));